import { render } from "./QuotationForm.vue?vue&type=template&id=054ab4ec&scoped=true&ts=true"
import script from "./QuotationForm.vue?vue&type=script&lang=ts"
export * from "./QuotationForm.vue?vue&type=script&lang=ts"

import "./QuotationForm.vue?vue&type=style&index=0&id=054ab4ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054ab4ec"]])

export default __exports__